import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Testimonial() {
  const testimonials = [
    {
      text: "Working with the team was smooth from day one. They understood our requirements quickly, communicated clearly, and delivered exactly what we needed. We'd happily work with them again",
      name: "Ethan Brooks",
    },
    {
      text: "The project was delivered on schedule, and the quality exceeded our expectations. Their attention to detail and proactive approach made the entire process stress-free",
      name: "Mia Carter",
    },
    {
      text: "Professional, responsive, and easy to collaborate with. Whenever we had questions or new ideas, the team was quick to provide practical solutions.",
      name: "Noah Bennett",
    },
    {
      text: "We appreciated the transparency throughout the project. Regular updates and excellent technical expertise gave us complete confidence in the final product",
      name: "Chloe Adams",
    },
    {
      text: "Their team treated our project like their own. The end result was clean, reliable, and exactly aligned with our business goals.",
      name: "Liam Foster",
    },
    {
      text: "From planning to deployment, everything was handled professionally. The experience was seamless, and we look forward to future collaborations.",
      name: "Ava Mitchell",
    },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 900,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    pauseOnHover: true,
    arrows: false,
    centerMode: true,
    centerPadding: "0px",
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          centerMode: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
    ],
  };

  return (
    <>
      {/* Side cards intentionally overflow the slider; clip them here so they can't widen the page. */}
      <section className="wrapper bg-light" style={{ overflowX: "clip" }}>
        <div className="container-fluid py-14 py-md-17 pb-16 pb-md-20 px-3 px-md-5 px-lg-8">
          <div className="row text-center mb-5">
            <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
              <h2 className="fs-16 text-uppercase text-muted mb-3">
                Client Feedback
              </h2>
              <h3 className="display-4 px-xl-10">What our clients say</h3>
            </div>
          </div>

          <div className="testimonial-card-slider-wrap">
            <style>{`
              .testimonial-card-slider-wrap {
                position: relative;
                padding: 20px 0 0 0;
              }
              .testimonial-card-slider-wrap .slick-list {
                overflow: visible !important;
                padding: 30px 0 0 !important;
              }
              .testimonial-card-slider-wrap .slick-track {
                display: flex !important;
                align-items: center !important;
              }
              .testimonial-card-slider-wrap .slick-slide {
                float: none !important;
                padding: 0 14px !important;
                transition: transform 0.45s ease, opacity 0.45s ease !important;
                opacity: 0.55 !important;
                transform: translateY(22px) scale(0.94) !important;
                pointer-events: none !important;
              }
              .testimonial-card-slider-wrap .slick-slide.slick-center {
                opacity: 1 !important;
                transform: translateY(-18px) scale(1.02) !important;
                pointer-events: auto !important;
                z-index: 10 !important;
                position: relative !important;
              }
              .testimonial-card-slider-wrap .slick-slide.slick-active:not(.slick-center) {
                opacity: 0.55 !important;
                transform: translateY(22px) scale(0.94) !important;
              }
              .testimonial-card-slider-wrap .slick-slide > div {
                width: 100%;
                height: 100%;
              }
              .testimonial-card {
                background: #ffffff;
                border-radius: 14px;
                padding: 34px 28px 40px 28px;
                box-shadow: 0 6px 20px rgba(20, 20, 40, 0.06);
                text-align: center;
                border: 1px solid rgba(0,0,0,0.05);
                transition: box-shadow 0.4s ease, transform 0.4s ease !important;
                min-height: 280px;
                display: flex !important;
                flex-direction: column !important;
                justify-content: flex-start !important;
                position: relative !important;
                overflow: visible !important;
              }
              .slick-center .testimonial-card {
                box-shadow: 0 14px 36px rgba(20, 20, 40, 0.10) !important;
                border-color: rgba(0, 0, 0, 0.06) !important;
              }
              .testimonial-card-quote-mark {
                font-family: Georgia, serif;
                font-size: 52px;
                line-height: 1;
                color: #e4e5eb;
                font-weight: 700;
                text-align: center;
                margin: 0 auto 16px auto;
                user-select: none;
              }
              .slick-center .testimonial-card-quote-mark {
                color: #d0d2db;
                font-size: 58px;
              }
              .testimonial-card-text-wrap {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                width: 100%;
              }
              .testimonial-card-text {
                font-size:18px;
                line-height: 1.75;
                color: #1d1e25;
                margin: 0;
                font-weight: 400;
                letter-spacing: 0.1px;
              }
              .slick-center .testimonial-card-text {
               font-size: 18px;
                line-height: 1.8;
                font-weight: 500;
                color: #1d1e25;
              }
              .testimonial-card-name-wrap {
                margin-top: 26px;
                width: 100%;
                text-align: center;
              }
              .testimonial-card-name {
                font-size: 18px;
                font-weight: 600;
                color: #394764;
                display: inline-block;
                padding: 0;
                border: none;
                margin: 0;
                letter-spacing: 0.2px;
              }
              .slick-center .testimonial-card-name {
                font-size: 18px;
                font-weight: 700;
                color: #2a3956;
              }
            `}</style>
            <Slider {...settings}>
              {testimonials.map((t, idx) => (
                <div key={idx}>
                  <div className="testimonial-card">
                    <div className="testimonial-card-quote-mark">&ldquo;</div>
                    <div className="testimonial-card-text-wrap">
                      <p className="testimonial-card-text">
                        {t.text.length > 150
                          ? t.text.substring(0, 150).trimEnd() + "\u2026"
                          : t.text}
                      </p>
                    </div>
                    <div className="testimonial-card-name-wrap">
                      <h6 className="testimonial-card-name">- {t.name}</h6>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
    </>
  );
}

export default Testimonial;
